var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shoRenewPasswordHelpMessage)?_c('banner',{attrs:{"color-scheme":"alert","banner-message":_vm.$t('PROFILE_SETTINGS.CHANGE_PASSWORD_HELP_TEXT')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }